<section class="config-container shadow">
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{ active: subStep === SubStep.Doors }"
    (click)="toggleCollapse()">
    <span>{{ 'closet-doors.finishes.structure' | translate }}</span>
    <span class="info" (click)="showInfoModal()">?</span>
  </h4>
  @if (subStep === SubStep.Doors) {
    <div class="collapse-block">
      @if (doorTypes) {
        <ul class="structures">
          @for (doorType of doorTypes; track doorType.id) {
            <li
              class="structure-card"
              [ngClass]="{ active: isDoorTypeSelected(doorType.id), disabled: !selectedDoorId }"
              (click)="selectDoorType(doorType)">
              <img [src]="baseImgURL + doorType.thumbnail" />
              <p>{{ doorType.titleFr }}</p>
            </li>
          }
        </ul>
      } @else {
        <ng-casto-loader></ng-casto-loader>
      }
    </div>
  }
</section>
